import { render, staticRenderFns } from "./SiteRecurringDocumentTable.vue?vue&type=template&id=626cc60b"
import script from "./SiteRecurringDocumentTable.vue?vue&type=script&lang=js"
export * from "./SiteRecurringDocumentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports